import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

//#region Creación de usuarios / Registro
export class MatchingPasswordsErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		return (control && (control.invalid || form?.hasError("PasswordsDontMatch")) && control.touched ) as boolean;
	}
}
//#endregion

//#region Filtrado de productos
export class MinMaxErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		return (control && (form?.hasError("InvalidMinMax")) && control.touched ) as boolean;
	}
}
//#endregion

//#region Formulario de dirección
export class AddressSearchErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		return (control && ((form?.hasError("NotWithinCABA")) || (form?.hasError("InvalidPlace"))) && control.touched ) as boolean;
	}
}
//#endregion

//#region Formulario de producto
export class PriceWithDiscountErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		return (control && (form?.hasError("PriceSmallerThanShippingPrice")) && control.touched ) as boolean;
	}
}
//#endregion